"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _memoizeOne = _interopRequireDefault(require("memoize-one"));

var _react = _interopRequireDefault(require("react"));

var _AdaptiveCardBuilder = require("../Utils/AdaptiveCardBuilder");

var _CommonCard = _interopRequireDefault(require("./CommonCard"));

var _connectToWebChat = _interopRequireDefault(require("../connectToWebChat"));

var _ImageContent = _interopRequireDefault(require("./ImageContent"));

var _VideoContent = _interopRequireDefault(require("./VideoContent"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

var AnimationCardAttachment =
/*#__PURE__*/
function (_React$Component) {
  _inherits(AnimationCardAttachment, _React$Component);

  function AnimationCardAttachment(props) {
    var _this;

    _classCallCheck(this, AnimationCardAttachment);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(AnimationCardAttachment).call(this, props));
    _this.buildCard = (0, _memoizeOne.default)(function (adaptiveCards, content) {
      var builder = new _AdaptiveCardBuilder.AdaptiveCardBuilder(adaptiveCards);
      (content.images || []).forEach(function (image) {
        return builder.addImage(image.url, null, image.tap);
      });
      builder.addCommon(content);
      return builder.card;
    });
    return _this;
  }

  _createClass(AnimationCardAttachment, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          adaptiveCards = _this$props.adaptiveCards,
          attachment = _this$props.attachment,
          styleSet = _this$props.styleSet;

      var _ref = attachment || {},
          _ref$content = _ref.content,
          content = _ref$content === void 0 ? {} : _ref$content;

      return _react.default.createElement("div", {
        className: styleSet.animationCardAttachment
      }, _react.default.createElement("ul", {
        className: "media-list"
      }, content.media.map(function (media, index) {
        return _react.default.createElement("li", {
          key: index
        }, /\.gif$/i.test(media.url) ? _react.default.createElement(_ImageContent.default, {
          alt: media.profile,
          src: media.url
        }) : _react.default.createElement(_VideoContent.default, {
          alt: media.profile,
          src: media.url
        }));
      })), _react.default.createElement(_CommonCard.default, {
        adaptiveCards: adaptiveCards,
        attachment: attachment
      }));
    }
  }]);

  return AnimationCardAttachment;
}(_react.default.Component);

var _default = (0, _connectToWebChat.default)(function (_ref2) {
  var styleSet = _ref2.styleSet;
  return {
    styleSet: styleSet
  };
})(AnimationCardAttachment);

exports.default = _default;